<template>
  <div id="app">
    <transition :name="transitionName">
      <keep-alive :include= include>
        <router-view  class="router" />
      </keep-alive>
    </transition>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      include:'',
      transitionName: "",
      show: true
    };
  },
  watch: {
    $route(to, from) {
      const toDepth = to.path.length;
      const fromDepth = from.path.length;
      this.transitionName = toDepth > fromDepth ? "slide-left" : "slide-right";
    }
  }
};
</script>

<style>
@import "assets/scss/index.scss";
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  height: 100%;
  overflow-y:auto;
  /* width: 100%; */
  color: #2c3e50;
}
</style>
